package gr.tech.GRAttestation.components.inputs

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.models.stores.STORE_STATUS
import gr.tech.GRAttestation.styles.GeneralInputErrorStyle
import gr.tech.GRAttestation.styles.InputContainerStyle
import gr.tech.GRAttestation.styles.bsInputLabelStyle
import gr.tech.GRAttestation.styles.bsInputStyle
import org.jetbrains.compose.web.attributes.required
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.dom.*

private val statusOptions = listOf(
    STORE_STATUS.ACTIVE,
    STORE_STATUS.DELETED
)

@Composable
fun StoreStatusDropdown(
    inputId: String = "storeStatusDropdown",
    labelText: String = "Status",
    selected: STORE_STATUS = STORE_STATUS.ACTIVE,
    hasError: Boolean = false,
    labelModifier: Modifier = Modifier.bsInputLabelStyle(),
    selectModifier: Modifier = Modifier.bsInputStyle(),
    onValueChange: (STORE_STATUS) -> Unit
) {

    Div(
        attrs = InputContainerStyle.toModifier()
            .flexDirection(FlexDirection.Column)
            .toAttrs()
    ) {
        Label(
            forId = inputId,
            attrs = labelModifier.toAttrs()
        ) {
            Text(labelText)
        }

        Select(
            attrs = selectModifier
                .id(inputId)
                .thenIf(hasError, GeneralInputErrorStyle.toModifier())
                .toAttrs {
                    required()
                    onChange { event ->
                        onValueChange(STORE_STATUS.parseStatus(event.target.value))
                    }
                }
        ) {
            statusOptions.forEach { status ->
                Option(
                    value = status.name,
                    attrs = Modifier.toAttrs {
                        if (status == selected) attr("selected", "")
                    }
                ) {
                    Text(status.name.lowercase().replaceFirstChar { it.uppercase() })
                }
            }
        }
    }
}
